export default __webpack_public_path__ + "static/media/settings.b2a959da.svg";